import * as React from 'react'

import { PdfOutlineItem } from './pdf-viewer.types'
import { usePdfViewerContext } from './pdf-viewer-provider'
import { ScrollArea } from '../ui/scroll-area'

function TocNode({ item, level }: { item: PdfOutlineItem; level: number }) {
  const { navigateToDestination } = usePdfViewerContext()

  return (
    <div>
      <button
        className="w-full rounded-md px-2 py-1.5 text-left text-sm text-white/85 transition hover:bg-white/10 hover:text-white"
        style={{ paddingLeft: `${8 + level * 12}px` }}
        onClick={async () => {
          await navigateToDestination(item.dest)
        }}
      >
        {item.title}
      </button>
      {item.items?.map((child, index) => (
        <TocNode key={`${child.title}-${index}-${level + 1}`} item={child} level={level + 1} />
      ))}
    </div>
  )
}

export function PdfViewerToc() {
  const { alignment, outline, setTocOpen, tocOpen } = usePdfViewerContext()

  if (!outline) {
    return null
  }

  const anchorClass = alignment === 'right' ? 'left-4' : 'right-4'
  const originClass = alignment === 'right' ? 'origin-bottom-left' : 'origin-bottom-right'
  const animationClass =
    alignment === 'right'
      ? tocOpen
        ? 'translate-x-0 opacity-100 scale-100'
        : '-translate-x-3 opacity-0 scale-95'
      : tocOpen
        ? 'translate-x-0 opacity-100 scale-100'
        : 'translate-x-3 opacity-0 scale-95'

  return (
    <div
      className={`absolute bottom-16 z-30 w-[min(88vw,320px)] rounded-xl border border-white/10 bg-black/85 text-white shadow-xl backdrop-blur transition-[opacity,transform] duration-150 ease-out motion-reduce:transition-none ${anchorClass} ${originClass} ${animationClass} ${
        tocOpen ? 'pointer-events-auto' : 'pointer-events-none'
      }`}
    >
      <div className="flex items-center justify-between border-b border-white/10 px-4 py-3">
        <span className="text-sm font-semibold">Table of Contents</span>
        <button
          className="rounded-md px-2 py-1 text-xs text-white/80 hover:bg-white/15 hover:text-white"
          onClick={() => setTocOpen(false)}
        >
          Hide
        </button>
      </div>
      <div className="p-2">
        <ScrollArea className="h-[calc(100vh-20rem)] pr-2">
          {outline.map((item, index) => (
            <TocNode key={`${item.title}-${index}`} item={item} level={0} />
          ))}
        </ScrollArea>
      </div>
    </div>
  )
}
